export const ENG_GOOGLE_PLAYSTORE = "https://play.google.com/store/apps/details?id=com.prothomalo.english";
export const ENG_APPLE_PLAYSTORE = "https://apps.apple.com/us/app/english-news-prothom-alo/id1289463331";
export const BN_GOOGLE_PLAYSTORE = "https://play.google.com/store/apps/details?id=com.mcc.prothomalo&hl=en_IN";
export const BN_APPLE_PLAYSTORE = "https://apps.apple.com/us/app/bangla-newspaper-prothom-alo/id548596669";
export const NA_APPLE_PLAYSTORE = "https://apps.apple.com/us/app/prothom-alo-north-america/id1289436839";

export const storyTemplatesList = [
  { key: "all", enLabel: "All", bnLabel: "সব" },
  { key: "text", enLabel: "Text", bnLabel: "টেক্সট" },
  { key: "photo", enLabel: "Photo", bnLabel: "ছবি" },
  { key: "video", enLabel: "Video", bnLabel: "ভিডিও" },
  { key: "live-blog", enLabel: "Live-Blog", bnLabel: "সরাসরি" },
  { key: "poll", enLabel: "Poll", bnLabel: "অনলাইন ভোট" },
];

export const sortingList = [
  { key: "default", enLabel: "Relevant", bnLabel: "প্রাসঙ্গিক" },
  { key: "latest-published", enLabel: "Latest", bnLabel: "নতুন থেকে পুরোনো" },
  { key: "published-at:asc", enLabel: "Oldest", bnLabel: "পুরোনো থেকে নতুন" },
];

export const prayerDistricts = {
  getDistrict(areaName) {
    return this.areas.find(({ name }) => name.toLowerCase() === areaName?.toLowerCase());
  },

  get districts() {
    return this.areas;
  },

  areas: [
    {
      name: "Coxsbazar",
      bnName: "কক্সবাজার",
      sehri: -6,
      iftar: -6,
    },
    {
      name: "Kishoreganj",
      bnName: "কিশোরগঞ্জ",
      sehri: -2,
      iftar: -2,
    },
    {
      name: "Comilla",
      bnName: "কুমিল্লা",
      sehri: -3,
      iftar: -3,
    },
    {
      name: "Kushtia",
      bnName: "কুষ্টিয়া",
      sehri: 6,
      iftar: 6,
    },
    {
      name: "Kurigram",
      bnName: "কুড়িগ্রাম",
      sehri: 6,
      iftar: 6,
    },
    {
      name: "Khagrachhari",
      bnName: "খাগড়াছড়ি",
      sehri: -7,
      iftar: -7,
    },
    {
      name: "Khulna",
      bnName: "খুলনা",
      sehri: 3,
      iftar: 3,
    },
    {
      name: "Gaibandha",
      bnName: "গাইবান্ধা",
      sehri: 6,
      iftar: 6,
    },
    {
      name: "Gazipur",
      bnName: "গাজীপুর",
      sehri: 1,
      iftar: 1,
    },
    {
      name: "Gopalganj",
      bnName: "গোপালগঞ্জ",
      sehri: 3,
      iftar: 3,
    },
    {
      name: "Chattogram",
      bnName: "চট্টগ্রাম",
      sehri: -5,
      iftar: -5,
    },
    {
      name: "Chandpur",
      bnName: "চাঁদপুর",
      sehri: -1,
      iftar: -1,
    },
    {
      name: "Chapainawabganj",
      bnName: "চাঁপাইনবাবগঞ্জ",
      sehri: 8,
      iftar: 8,
    },
    {
      name: "Chuadanga",
      bnName: "চুয়াডাঙ্গা",
      sehri: 6,
      iftar: 6,
    },
    {
      name: "Jamalpur",
      bnName: "জামালপুর",
      sehri: 2,
      iftar: 2,
    },
    {
      name: "Joypurhat",
      bnName: "জয়পুরহাট",
      sehri: 0,
      iftar: 0,
    },
    {
      name: "Jhalakathi",
      bnName: "ঝালকাঠি",
      sehri: 1,
      iftar: 1,
    },
    {
      name: "Jhenaidah",
      bnName: "ঝিনাইদহ",
      sehri: 6,
      iftar: 6,
    },
    {
      name: "Tangail",
      bnName: "টাঙ্গাইল",
      sehri: 2,
      iftar: 2,
    },
    {
      name: "Thakurgaon",
      bnName: "ঠাকুরগাঁও",
      sehri: 6,
      iftar: 6,
    },
    {
      name: "Dhaka",
      bnName: "ঢাকা",
      sehri: 0,
      iftar: 0,
    },
    {
      name: "Dinajpur",
      bnName: "দিনাজপুর",
      sehri: 6,
      iftar: 6,
    },
    {
      name: "Naogaon",
      bnName: "নওগাঁ",
      sehri: 8,
      iftar: 8,
    },
    {
      name: "Narail",
      bnName: "নড়াইল",
      sehri: 3,
      iftar: 3,
    },
    {
      name: "Narsingdi",
      bnName: "নরসিংদী",
      sehri: -1,
      iftar: -1,
    },
    {
      name: "Natore",
      bnName: "নাটোর",
      sehri: 8,
      iftar: 8,
    },
    {
      name: "Narayanganj",
      bnName: "নারায়ণগঞ্জ",
      sehri: -1,
      iftar: -1,
    },
    {
      name: "Nilphamari",
      bnName: "নীলফামারী",
      sehri: 6,
      iftar: 6,
    },
    {
      name: "Netrokona",
      bnName: "নেত্রকোণা",
      sehri: -3,
      iftar: -3,
    },
    {
      name: "Noakhali",
      bnName: "নোয়াখালী",
      sehri: -4,
      iftar: -4,
    },
    {
      name: "Panchagarh",
      bnName: "পঞ্চগড়",
      sehri: 6,
      iftar: 11,
    },
    {
      name: "Patuakhali",
      bnName: "পটুয়াখালী",
      sehri: -2,
      iftar: -2,
    },
    {
      name: "Pabna",
      bnName: "পাবনা",
      sehri: 4,
      iftar: 4,
    },
    {
      name: "Pirojpur",
      bnName: "পিরোজপুর",
      sehri: 1,
      iftar: 1,
    },
    {
      name: "Faridpur",
      bnName: "ফরিদপুর",
      sehri: 3,
      iftar: 3,
    },
    {
      name: "Feni",
      bnName: "ফেনী",
      sehri: -4,
      iftar: -4,
    },
    {
      name: "Bogura",
      bnName: "বগুড়া",
      sehri: 7,
      iftar: 7,
    },
    {
      name: "Barguna",
      bnName: "বরগুনা",
      sehri: 1,
      iftar: 1,
    },
    {
      name: "Barisal",
      bnName: "বরিশাল",
      sehri: 1,
      iftar: 1,
    },
    {
      name: "Bagerhat",
      bnName: "বাগেরহাট",
      sehri: 2,
      iftar: 2,
    },
    {
      name: "Bandarban",
      bnName: "বান্দরবান",
      sehri: -7,
      iftar: -7,
    },
    {
      name: "Brahmanbaria",
      bnName: "ব্রাহ্মণবাড়িয়া",
      sehri: -3,
      iftar: -3,
    },
    {
      name: "Bhola",
      bnName: "ভোলা",
      sehri: -2,
      iftar: -2,
    },
    {
      name: "Magura",
      bnName: "মাগুরা",
      sehri: 4,
      iftar: 4,
    },
    {
      name: "Madaripur",
      bnName: "মাদারীপুর",
      sehri: 1,
      iftar: 1,
    },
    {
      name: "Manikganj",
      bnName: "মানিকগঞ্জ",
      sehri: 2,
      iftar: 2,
    },
    {
      name: "Munshiganj",
      bnName: "মুন্সিগঞ্জ",
      sehri: -1,
      iftar: -1,
    },
    {
      name: "Meherpur",
      bnName: "মেহেরপুর",
      sehri: 7,
      iftar: 7,
    },
    {
      name: "Moulvibazar",
      bnName: "মৌলভীবাজার",
      sehri: -6,
      iftar: -6,
    },
    {
      name: "Mymensingh",
      bnName: "ময়মনসিংহ",
      sehri: 2,
      iftar: 2,
    },
    {
      name: "Jashore",
      bnName: "যশোর",
      sehri: 6,
      iftar: 6,
    },
    {
      name: "Rangpur",
      bnName: "রংপুর",
      sehri: 6,
      iftar: 6,
    },
    {
      name: "Rangamati",
      bnName: "রাঙ্গামাটি",
      sehri: -7,
      iftar: -7,
    },
    {
      name: "Rajbari",
      bnName: "রাজবাড়ী",
      sehri: 4,
      iftar: 4,
    },
    {
      name: "Rajshahi",
      bnName: "রাজশাহী",
      sehri: 7,
      iftar: 7,
    },
    {
      name: "Lakshmipur",
      bnName: "লক্ষ্মীপুর",
      sehri: -2,
      iftar: -2,
    },
    {
      name: "Lalmonirhat",
      bnName: "লালমনিরহাট",
      sehri: 7,
      iftar: 7,
    },
    {
      name: "Shariatpur",
      bnName: "শরীয়তপুর",
      sehri: 1,
      iftar: 1,
    },
    {
      name: "Sherpur",
      bnName: "শেরপুর",
      sehri: 2,
      iftar: 2,
    },
    {
      name: "Satkhira",
      bnName: "সাতক্ষীরা",
      sehri: 6,
      iftar: 6,
    },
    {
      name: "Sirajganj",
      bnName: "সিরাজগঞ্জ",
      sehri: 3,
      iftar: 3,
    },
    {
      name: "Sylhet",
      bnName: "সিলেট",
      sehri: -6,
      iftar: -6,
    },
    {
      name: "Sunamganj",
      bnName: "সুনামগঞ্জ",
      sehri: -4,
      iftar: -4,
    },
    {
      name: "Habiganj",
      bnName: "হবিগঞ্জ",
      sehri: -4,
      iftar: -4,
    },
  ],
};
